import axios from 'axios';

const setAuthToken = token => {
  if (token) {
    // * Todos os pedidos são feitos com o token [Authorization Bearer]
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

export default setAuthToken;
